function lazyLoadSection({
  triggerSelector,
  containerSelector,
  sectionUrl,
  onLoad
}) {
  const trigger = document.querySelector(triggerSelector);
  const container = document.querySelector(containerSelector);
  if (!trigger || !container) return;

  const observer = new IntersectionObserver(function (entries) {
    if (!entries[0].isIntersecting) return;

    $.get(sectionUrl, function (html) {
      container.innerHTML = html;
      if (typeof onLoad === 'function') {
        onLoad(container);
      }
    });

    observer.disconnect();
    trigger.remove();
  });

  observer.observe(trigger);
}

function loadImage() {
  $('.squelette img').each(function() {
    if (this.complete) {
      $(this).closest('.squelette').find('.squelette-bg').removeClass('squelette-bg');
      $(this).closest('.squelette').removeClass('squelette');
    } else {
      $(this).on('load', function () {
          $(this).closest('.squelette').find('.squelette-bg').removeClass('squelette-bg');
          $(this).closest('.squelette').removeClass('squelette');
      });
    }
  });
}

function celluleMere(container) {
  $(container).find('.cellule-produit.mere').each(function () {
    const produitScript = this.querySelector('.produit-data');
    const celluleScript = this.querySelector('.cellule-data');
    if (produitScript && celluleScript) {
      let produit_data = JSON.parse(produitScript.textContent);
      let cellule_data = JSON.parse(celluleScript.textContent);
      let novo_cell = celluleMereData(produit_data, cellule_data);
      
      celluleMereMod(produit_data, novo_cell, $(this));
    }
  });
}

function celluleMereData(produit_data, cellule_data) {
  let novo_cell = [];
  let taille_ou_opt = (produit_data.taille == "" && produit_data.opt1 != "") ? "opt" : "taille";

  for (let i = 0; i < cellule_data.length; i++) {
    const data = cellule_data[i];

    let cellule_index;
    if(taille_ou_opt == "opt") {
      cellule_index = novo_cell.findIndex(el => el.opt_perso === data.opt1);
    } else if (taille_ou_opt == "taille") {
      cellule_index = novo_cell.findIndex(el => el.taille === data.taille);
    }

    if(cellule_index != -1) {
      novo_ref = novo_cell[cellule_index];
      if(Number((novo_ref.prix).replace('.', '').replace(' €', '')) > Number((data.prix).replace('.', '').replace(' €', ''))) {
        novo_ref.prix = data.prix;
      }

      let OTcheck = false;
      if(taille_ou_opt == "opt") {
        OTcheck = (novo_ref.taille == data.taille);
      } else if (taille_ou_opt == "taille") {
        OTcheck = (novo_ref.opt_perso == data.opt1);
      }
      if(OTcheck  && data.tissus == produit_data.tissus && data.sens == produit_data.sens && data.structure == produit_data.structure
                  && data.pieds == produit_data.pieds && data.accoudoir == produit_data.accoudoir
                  && data.opt2 == produit_data.opt2 && data.opt3 == produit_data.opt3) {
        novo_ref.image = data.image;
        novo_ref.url = data.url;
      }
    } else {
      novo_cell.push({
        taille: data.taille,
        opt_perso: data.opt1,
        longueur: data.longueur,
        prix: data.prix,
        image: data.image,
        url: data.url
      });
    }
  }

  // sort
  if(taille_ou_opt == "opt") {
    novo_cell.sort(function(a, b) {
      if (a.opt_perso < b.opt_perso) return -1;
      else if (a.opt_perso > b.opt_perso) return 1;
      else return 0;
    });
  } else if (taille_ou_opt == "taille") {
    novo_cell.sort(function(a, b) {
      if (a.taille < b.taille) return -1;
      else if (a.taille > b.taille) return 1;
      else return 0;
    });
  }

  //spécial corner
  if(produit_data.type == "Corner" || produit_data.type == "Corner déhoussable") {
    for(let i = 0; i < novo_cell.length; i++) {
      novo_cell[i].taille += ' (' + novo_cell[i].longueur + ' cm)';
    }
  }

  return novo_cell;
}

function celluleMereMod(produit_data, novo_cell, cell_ref) {
  let taille_ou_opt = (produit_data.taille == "" && produit_data.opt1 != "") ? "opt" : "taille";

  if(novo_cell.length > 1) {
    let cadre_html = '';
    for(let i = 0; i < novo_cell.length; i++) {
      let OTvalue = (taille_ou_opt == "opt") ? novo_cell[i].opt_perso : novo_cell[i].taille;
      cadre_html += '<a data-prix="' + novo_cell[i].prix + '" data-image="' + novo_cell[i].image +
                    '" href="' + novo_cell[i].url + '">' + OTvalue + '</a>';
    }
    cell_ref.find('.image .cadre').html(cadre_html);
    cell_ref.find('.image .cadre').removeClass('gros-lien');
  } else cell_ref.find('.image .cadre a').data("prix", "ERR");

  for(let i = 0; i < novo_cell.length; i++) {
    if((taille_ou_opt == "opt" && novo_cell[i].opt_perso == produit_data.opt1) ||
       (taille_ou_opt == "taille" && novo_cell[i].taille == produit_data.taille)) {
      cell_ref.find('.info .prix').html(novo_cell[i].prix);
      break;
    }
  }
}

function configurerPanier(vide) {
  $('.cart-upsale-config-close').click();
  $('.cart-upsale-close').click();
  $('.cart-divider').addClass('hide');
  $('.cart-message').addClass('hide');
  $('.cart-toggle-upsale').addClass('hide');
  
  if(vide) {
    $('.cart-content .empty').removeClass('hide');
    $('.sidebar-footer.sf-cart').addClass('hide');
    $('.sidebar-footer.sf-cart.sidebar-close').removeClass('hide');
  } else {
    $('.cart-content .empty').addClass('hide');
    $('.sidebar-footer.sf-cart').removeClass('hide');
    $('.sidebar-footer.sf-cart.sidebar-close').addClass('hide');
  }
}

function configurerPanierUpsell(sofaCount, upsellCount) {
    const upsellCountPerSofa = 2; // = 0 pour désactiver.
    if(upsellCountPerSofa > 0 && (upsellCount / upsellCountPerSofa) < sofaCount) {
      $('.cart-notfree').addClass('hide');
      $('.cart-free').removeClass('hide');
    } else {
      $('.cart-notfree').removeClass('hide');
      $('.cart-free').addClass('hide');
    }
}

function configurerPanierSofa() {
  $('.cart-message').removeClass('hide');
  $('.cart-toggle-upsale .icon-arrow-right').removeClass('hide');
  $('.cart-toggle-upsale .icon-arrow-left').addClass('hide');
  $('.cart-toggle-upsale').removeClass('hide');
  $('.cart-upsale').removeClass('close-upsale');
}

function configurerPanierSofaMobile() {
  $('.cart-message').removeClass('hide');
  $('.cart-toggle-upsale .icon-arrow-right').addClass('hide');
  $('.cart-toggle-upsale .icon-arrow-left').removeClass('hide');
  $('.cart-toggle-upsale').removeClass('hide');
  $('.cart-upsale').addClass('close-upsale');
}

function ajouterLignePanier({key, url, image, titre, couleur, quantite, etiquette, prix, reduction}) {
  var newItem = $('.cart-item-model').clone(true).insertBefore($(".cart-message").last()).removeClass('cart-item-model').removeClass('hide');
  newItem.attr('data-key', key);
  newItem.find('.image').attr('href', url);
  newItem.find('.image img').attr('src', image);
  newItem.find('.titre').html(titre);
  newItem.find('.couleur').html(couleur);
  newItem.find('.nombre p').html(quantite);
  newItem.find('.etiquette').html(etiquette);
  newItem.find('.price .cart-price').html(prix);
  if(prix != reduction) newItem.find('.price .cart-price-reduc').html(reduction);
}

function ajouterUpsellPanier({key, url, image, titre, couleur, quantite, etiquette, prix, reduction}) {
  var newItem = $('.cart-item-model').clone(true).insertAfter($(".cart-divider").last()).removeClass('cart-item-model').removeClass('hide');
  newItem.attr('data-key', key);
  newItem.find('.image').attr('href', url);
  newItem.find('.image img').attr('src', image);
  newItem.find('.titre').html(titre);
  newItem.find('.couleur').html(couleur);
  newItem.find('.nombre p').html(quantite);
  newItem.find('.etiquette').html(etiquette);
  newItem.find('.price .cart-price').html(prix);
  if(prix != reduction) newItem.find('.price .cart-price-reduc').html(reduction);
}